import { User } from '@kaizenplatform/intelligence-entity';
import State from '../core/State';
import produce, { Draft } from 'immer';

export const startAuthentication = () =>
  produce((draft: Draft<State>) => {
    draft.authentication.fetching = draft.authentication.fetching + 1;
  });

export const finishAuthentication = () =>
  produce((draft: Draft<State>) => {
    draft.authentication.fetching = draft.authentication.fetching - 1;
  });

export const setSignedInUser = (user: User) =>
  produce((draft: Draft<State>) => {
    draft.authentication.signedInUser = user;
  });

export const disposeUser = () =>
  produce((draft: Draft<State>) => {
    draft.authentication.signedInUser = null;
  });

export const setToken = (token: string) =>
  produce((draft: Draft<State>) => {
    draft.authentication.token = token;
  });

export const disposeToken = () =>
  produce((draft: Draft<State>) => {
    draft.authentication.token = null;
  });
